export default __webpack_public_path__ + "static/media/img_muslinTwoBibsTwoEars_yg_p.c20f6ff7.jpg";